






import { createComponent } from "@vue/composition-api";

interface BaseNumericTagProps {
  value: number;
}

export default createComponent({
  props: {
    value: {
      required: true,
      type: Number
    }
  },
  setup(props: Readonly<BaseNumericTagProps>, context) {}
});
